import React from "react";
import { IParagraphVideoBlockProps } from "./ParagraphVideoBlockProps";
import { Styledcontainer } from "./ParagraphVideoBlockHelpers";
import { graphql } from "gatsby";
import VideoPlayer from "../../common/VideoPlayer/VideoPlayer";

const ParagraphVideoBlock: React.FC<IParagraphVideoBlockProps> = (props) => {
  return (
    <Styledcontainer>
      <VideoPlayer url={props?.node?.field_link?.url} />
    </Styledcontainer>
  );
};

export const fragment = graphql`
  fragment ParagraphVideoBlock on paragraph__video_block {
    id
    field_link {
      url
    }
  }
`;

export default ParagraphVideoBlock;
